export const ACTOR_OPTIONS = [
	{value: 'D', label: "Dean Approved"},
	{value: 'H', label: "Host Approved"},
	{value: 'P', label: "Parent Approved"}

];

export const STUDENT_OPTIONS = [
	{value: 'F', label: "First Name"},
	{value: 'L', label: "Last Name"}
	
];